/**
 * Floor-plan pixel coords for the current camera.
 * Prefer localized true pose when present and finite; otherwise planned waypoint.
 */
export function resolveCameraPlanCoords(
  plannedX: number,
  plannedY: number,
  trueX?: string | number | null,
  trueY?: string | number | null,
): { x: number; y: number } {
  if (trueX == null || trueX === '' || trueY == null || trueY === '') {
    return { x: plannedX, y: plannedY }
  }
  const x = typeof trueX === 'number' ? trueX : parseFloat(String(trueX))
  const y = typeof trueY === 'number' ? trueY : parseFloat(String(trueY))
  if (!Number.isFinite(x) || !Number.isFinite(y)) {
    return { x: plannedX, y: plannedY }
  }
  return { x, y }
}
